/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import { Component } from 'react';

class BasePage extends Component {

    loadContentMessage = () => {}

    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.loadContentMessage && this.loadContentMessage();
        }
    }
    componentWillMount() {
        this.scrollToTop();
    }

    scrollToTop = () => {
        window.scrollTo(0, 0)
    }
}

export default BasePage;


// WEBPACK FOOTER //
// ./src/shared/BasePage/index.js